/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';

import image1 from '../assets/image1.png';
import image10 from '../assets/image10.png';
import image12 from '../assets/image12.png';
import image13 from '../assets/image13.png';
import image14 from '../assets/image14.png';
import image15 from '../assets/image15.png';
import image16 from '../assets/image16.png';
import image17 from '../assets/image17.png';
import image18 from '../assets/image18.png';
import image19 from '../assets/image19.png';
import image2 from '../assets/image2.png';
import image20 from '../assets/image20.png';
import image21 from '../assets/image21.png';
import image22 from '../assets/image22.png';
import image23 from '../assets/image23.png';
import image24 from '../assets/image24.png';
import image25 from '../assets/image25.png';
import image3 from '../assets/image3.png';
import image4 from '../assets/image4.png';
import image44 from '../assets/image44.png';
import image45 from '../assets/image45.png';
import image5 from '../assets/image5.png';
import image6 from '../assets/image6.png';
import image7 from '../assets/image7.png';
import image8 from '../assets/image8.png';
import image9 from '../assets/image9.png';

export const InterfaceInstructionContent: React.FC = () => (
  <>
    <div className="instruction__section">
      <div className="instruction__section-title">Рыночные сигналы </div>
      <div className="instruction__section-subtitle">1. Открытие позиции</div>
      <p className="instruction__paragraph">При подаче рыночного сигнала система устанавливает ряд ограничений.</p>
      <ul className="instruction__list">
        <li>
          <b>Минимальный объем</b> – параметр показывает минимально допустимый объем сделки <br />
          в процентах. Параметр рассчитывается на основе минимального порога входа в <br />
          стратегию и стоимости лота инструмента, по которому планируется сделка.
          <br />
          Ограничение обеспечивает исполнение сигнала у всех клиентов, подключенных на стратегию.
          <span className="instruction__italic">
            <br />
            Пример:
            <br />
            минимальная сумма на стратегию: 15000 тысяч рублей
            <br />
            стоимость одного лота: 2025.80 рублей
            <br />
            <br />
            Минимальный объем сделки: 13.5%
          </span>
        </li>
        <li>
          <b>Максимальный объем</b> – устанавливает максимальный объем сделки в соответствии с<br />
          паспортом стратегии
        </li>
        <li>
          <b>Ограничения SL/TP</b> –c целью минимизации заведомо убыточных для клиентов сделок
          <br />
          ограничения по уровням TP и SL устанавливаются на уровнях, отличающихся от <br />
          текущей цены не менее чем на 0.2%
        </li>
      </ul>
      <p className="instruction__paragraph">
        В случае если устанавливаемые автором уровни не попадают в разрешенные диапазоны – в форме
        <br />
        подачи сигнала появляется соответствующее предупреждение, и отправка сигнала <br />
        будет невозможна (кнопка неактивна).
      </p>
      <p className="instruction__paragraph">
        В случае если в портфеле уже есть открытая позиция по выбранному инструменту,
        <br />
        ее объем отобразится в поле «текущая позиция» и также будет участвовать в<br />
        расчете максимально допустимого объема новой сделки.
      </p>
      <img src={image1} className="instruction__image" />

      <div className="instruction__section-subtitle">2. Полное закрытие позиции</div>
      <p className="instruction__paragraph">
        При установленных в сигнале уровнях SL или TP закрытие позиции произойдет
        <br />
        автоматически при достижении цены указанного уровня.
      </p>
      <p className="instruction__paragraph">
        Для ручного закрытия позиции по текущей цене необходимо нажать на «Х» справа от <br />
        соответствующей позиции во вкладке «открытые позиции».
      </p>
      <img src={image2} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        После нажатия появится всплывающее окно с подтверждением сделки, в котором автор по <br />
        желанию может указать комментарий. Комментарии автора к сделкам автоматически <br />
        публикуются на сайте fintarget.ru в блоке «Последние сделки»
      </p>
      <img src={image3} className="instruction__image" />
      <div className="instruction__section-subtitle">3. Частичное закрытие позиции по рынку</div>
      <p className="instruction__paragraph">
        Для частичного закрытия позиции необходимо сформировать сигнал по нужному инструменту
        <br />и указать соответствующую долю, которую необходимо закрыть.
      </p>
      <p className="instruction__paragraph">
        При этом не допускается частичное закрытие с таким объемом сделки, в результате
        <br />
        исполнения которого, оставшаяся доля по позиции будет меньше, чем минимально
        <br />
        допустимая доля по данному инструменту.
      </p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Отложенные сигналы </div>
      <p className="instruction__paragraph">
        Позволяет выставить сигнал по одному инструменту по заранее заданной цене, которой сейчас <br />
        нет на рынке.
      </p>
      <p className="instruction__paragraph">
        При достижении котировки заданной цены по подключенным счетам выставляется айсберг <br />
        заявка по заданной цене, которая будет стоять на рынке до истечения указанного времени <br />
        действия, либо до исполнения поручений. По истечению времени действия оставшихся <br />
        клиентов сбалансирует по стандартному алгоритму.
      </p>
      <p className="instruction__paragraph">
        Чтобы подать отложенную заявку нажмите кнопку <strong>Новый сигнал</strong> на странице вашей <br /> Стратегии.
      </p>
      <p className="instruction__paragraph">
        Вверху появившегося окна вы увидите соответствующий вариант сигнала –{' '}
        <strong>
          Отложенный
          <br /> сигнал
        </strong>
        :
      </p>
      <img src={image4} className="instruction__image" />

      <p className="instruction__paragraph">
        В поле <strong>Поиск инструмента</strong> найдите нужный инструмент и выберите его из списка.
      </p>
      <img src={image44} className="instruction__image" />

      <p className="instruction__paragraph">
        Заполните параметры <strong>Объем позиции, Цена, Время действия</strong>.
      </p>
      <img src={image45} className="instruction__image" />

      <p className="instruction__paragraph">
        Время действия (минуты) – задается сколько времени даётся на исполнение сигнала по <br />
        заданной цене. По его окончанию все оставшиеся неисполненными ордера будут сняты и <br />
        дальнейшее исполнение продолжится уже по стандартным алгоритмам, как в других типах <br />
        сигналов.
      </p>
      <p className="instruction__paragraph">
        Выберите <strong>тип сигнала – Покупка, Продажа, Закрытие</strong>
      </p>
      <p className="instruction__paragraph">
        После того как внесены все параметры и выбрана цена нажмите кнопку{' '}
        <strong>
          Сформировать <br />
          сигнал
        </strong>
        .
      </p>

      <img src={image5} className="instruction__image" />

      <p className="instruction__paragraph">В случае успеха отобразится сообщение что сигнал принят</p>
      <img src={image6} className="instruction__image" />

      <p className="instruction__paragraph">
        Выставленный отложенный сигнал можно отслеживать в разделе Стратегия{`->`} Отложенные
        <br />
        сигналы
      </p>
      <img src={image7} className="instruction__image" />

      <p className="instruction__paragraph">
        В данном разделе также можно отменить ранее выставленный отложенный сигнал
      </p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Пакетные заявки</div>
      <p className="instruction__paragraph">
        Пакетная заявка позволяет одновременно исполнить несколько сигналов в рамках Стратегии. Например, если вам нужно
        закрыть несколько текущих позиций и открыть новые.
      </p>
      <p className="instruction__paragraph">
        Пакетная заявка представляет собой набор Рыночных сигналов, которые исполняются одновременно по счетам клиентов
        на Стратегии. Отличием от одиночных Рыночных сигналов является то, что они исполняются не последовательно, а
        сразу. Это позволяет избежать лишних балансировок по счетам. Например, если последовательно выставлять несколько
        одиночных Рыночных сигналов, то в промежутке между ними в Стратегии доля свободных средств будет увеличиваться,
        что может приводить к лишней продаже фин. инструментов на счетах для увеличения доля свободных средств клиентов.
      </p>
      <p className="instruction__paragraph">
        Чтобы подать пакетную заявку нажмите кнопку <b>Новый сигнал</b> на странице вашей Стратегии.
      </p>
      <p className="instruction__paragraph">
        Вверху появившегося окна вы увидете соответствующий вариант сигнала – <b>Пакетная заявка</b>:
      </p>
      <img src={image8} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Произведите поиск нужного инструмента. Все параметры будут аналогичны <b>Рыночному сигналу</b>: "Объем позиции в
        %", уровень Stop Loss (опционально), уровень Take Profit (опционально) и тип сигнала – Покупка, Продажа,
        Закрытие.
      </p>
      <p className="instruction__paragraph">
        После того как внесены все параметры – нажмите кнопку <b>Добавить в список</b>. Сигнал отобразится в списке
        справа:
      </p>
      <img src={image9} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">Повторите данное действие для всех необходимых инструментов.</p>
      <img src={image10} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        После того как набор инструментов сформирован нажмите кнопку <b>Сформировать сигнал</b>. Вы увидите
        подтверждающее сообщение:
      </p>
      <img src={image24} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Всё. Сигналы приняты системой. Вы сможете их увидеть в Истории сделок и в открытых позициях (если были открыты
        новые).
      </p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Портфельный сигнал</div>
      <p className="instruction__paragraph">
        Портфельный сигнал позволяет изменять весь текущий состав стратегии. Например, если вы хотите выровнять доли по
        всем инструментам в стратегии и/или заменить несколько инструментов, либо изменить по ним направление с Long на
        Short или наоборот.
      </p>
      <p className="instruction__paragraph">
        <b>Внимание!</b> Подача портфельного сигнала приводит к полной перебалансировки. Т.е. все текущие позиции в
        стратегии будут закрыты и открыты заново в соответствии с внесенными изменениями в рамках сигнала. На клиентах
        это приведёт к тому что у них пройдет ребалансировка на дельту между изначальной позицией и измененной.
        Например, до подачи сигнала была открыта позиция long по Сбербанку на 10%, после подачи сигнала позиция
        изменилась long по Сбербанку на 12%. В результате клиентам будет докуплено 2% Сбербанка.
      </p>
      <p className="instruction__paragraph">
        Чтобы подать Портфельный сигнал нажмите кнопку <b>Новый сигнал</b> на странице вашей Стратегии.
      </p>
      <p className="instruction__paragraph">
        Вверху появившегося окна Вы увидите соответствующий вариант сигнала&nbsp;&mdash; <b>Портфельный сигнал</b>:
      </p>
      <img src={image12} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Справа Вы увидите текущей состав стратегии. По значку <img src={image13} /> можно удалить инструмент из состава.
        По значку <img src={image14} /> левая часть окна заполнится данными для редактирования позиции:
      </p>
      <img src={image15} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Вы можете изменить инструмент, объем, уровни Stop Loss, Take Profit, а также изменить направление позиции с Long
        на Short или наоборот (Внимание! Некоторые инструменты недоступны для позиций Short. Для таких инструментов
        изменить направление позиции невозможно). Внеся все необходимые изменения нажмите кнопку <b>Внести изменения</b>
        . По её нажатию выбранная позиция соответственно изменится в списке справа.
      </p>
      <p className="instruction__paragraph">
        Также Вы можете добавить новый инструмент в стратегию. Для этого не выбирая никакую из позиций в списке справа,
        просто найдите нужный инструмент в поле Поиск инструмента в левой части окна. Тут также можно задать объем,
        уровни Stop Loss, Take Profit и направление сигнала. После внесения всех необходимых данных нажмите кнопку{' '}
        <b>Добавить</b> в список.
      </p>
      <img src={image16} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Внеся все необходимые изменения нажмите кнопку <b>Сохранить изменения</b>:
      </p>
      <img src={image17} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        После этого система закроет все текущие позиции по стратегии и откроет их заново в соответствии с новым
        составом, который был определен в рамках <b>Портфельного сигнала</b>.
      </p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Лимитная заявка</div>
      <p className="instruction__paragraph">
        Позволяет выставить сигнал по одному инструменту по заданной цене. При лимитной заявке по подключенным счетам
        выставляется айсберг заявка по заданной цене, которая будет стоять на рынке до истечения указанного времени
        действия, либо до исполнения поручений. По истечению времени действия оставшихся клиентов сбалансирует по
        стандартному алгоритму.
      </p>
      <p className="instruction__paragraph">
        Чтобы подать лимитную заявку нажмите кнопку <b>Новый сигнал</b> на странице вашей Стратегии.
      </p>
      <p className="instruction__paragraph">
        Вверху появившегося окна вы увидите соответствующий вариант сигнала – <b>Лимитная заявка</b>:
      </p>
      <img src={image21} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Главной особенностью лимитной заявки является то что у вас есть возможность выбрать цену из стакана, либо задать
        её вручную.
      </p>
      <img src={image22} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        Указанная цена не должна выходить за границы текущего стакана по инструменту. В ином случае будет выведена
        соответствующая ошибка.
      </p>
      <img src={image23} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">Прежде чем задавать цену рекомендуем выставить все остальные параметры:</p>
      <ul className="instruction__list">
        <li>"Объем позиции в %"</li>
        <li>уровень Stop Loss (опционально)</li>
        <li>уровень Take Profit (опционально)</li>
        <li>тип сигнала – Покупка, Продажа, Закрытие</li>
        <li>
          Время действия (минуты) – <b>уникальный параметр</b>, используется только в Лимитной заявке. В нём задается
          сколько времени даётся на исполнение сигнала по заданной цене. По его окончанию все оставшиеся неисполненными
          ордера будут сняты и дальнейшее исполнение продолжится уже по стандартным алгоритмам, как в других типах
          сигналов.
        </li>
      </ul>
      <p className="instruction__paragraph">
        После того как внесены все параметры и выбрана цена нажмите кнопку <b>Сформировать сигнал</b>В случае успеха
        отобразится сообщение что сигнал принят
      </p>
      <img src={image24} className="instruction__image" />
      <p className="instruction__paragraph">
        После того как Лимитная заявка принята системой начнётся отсчёт Времени действия.
        <b>Новый сигнал нельзя будет подать</b> пока Время действия не истечёт, либо не останется текущих действующих
        поручений по клиентам
      </p>
      <img src={image25} className="instruction__image" />
      <p className="instruction__paragraph">
        Если всё-таки необходимо подать новый сигнал, не дожидаясь окончания Лимитной заявки, нажмите Отменить лимитную
        заявку. Это приведёт к снятию текущих действующих поручений по клиентам, по которым сигнал ещё не успел
        исполнится.
      </p>
    </div>

    <div className="instruction__section">
      <div className="instruction__section-title">Замена позиции</div>
      <p className="instruction__paragraph">
        Если Вы хотите заменить позиции по одному из инструментов в стратегии на другой инструмент сохранив при этом вес
        позиции, то Вы можете воспользоваться функцией <b>Замена позиции</b>.
      </p>
      <p className="instruction__paragraph">
        Данная функция доступна на странице состава Вашей стратегии. Найдите значок <img src={image14} /> справа от
        нужной позиции.
      </p>
      <img src={image18} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        По нажатию на него откроется окно <b>Замена позиции</b>:
      </p>
      <img src={image19} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        В поле Поиск инструмента найдите нужный инструмент и нажмите <b>Заменить</b>
      </p>
      <img src={image20} className="instruction__image instruction__image-large" />
      <p className="instruction__paragraph">
        После этого текущая позиция по старому инструменту будет закрыта и открыта новая позиция с тем же весом по
        новому инструменту.
      </p>
    </div>
  </>
);
